/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';
import {
    WorkspaceMemberCampaignListItem,
    WorkspaceMemberCampaignListItemFromJSON,
    WorkspaceMemberCampaignListItemFromJSONTyped,
    WorkspaceMemberCampaignListItemToJSON,
} from './WorkspaceMemberCampaignListItem';

/**
 * 
 * @export
 * @interface WorkspaceMemberCampaignsResponse
 */
export interface WorkspaceMemberCampaignsResponse {
    /**
     * 
     * @type {Array<WorkspaceMemberCampaignListItem>}
     * @memberof WorkspaceMemberCampaignsResponse
     */
    results: Array<WorkspaceMemberCampaignListItem>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof WorkspaceMemberCampaignsResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof WorkspaceMemberCampaignsResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof WorkspaceMemberCampaignsResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof WorkspaceMemberCampaignsResponse
     */
    hasPreviousPage?: boolean;
}

export function WorkspaceMemberCampaignsResponseFromJSON(json: any): WorkspaceMemberCampaignsResponse {
    return WorkspaceMemberCampaignsResponseFromJSONTyped(json, false);
}

export function WorkspaceMemberCampaignsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMemberCampaignsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(WorkspaceMemberCampaignListItemFromJSON)),
        'listResult': QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function WorkspaceMemberCampaignsResponseToJSON(value?: WorkspaceMemberCampaignsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(WorkspaceMemberCampaignListItemToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

